import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body, #root { height: 100%; }   /* utile per layout full-height */

  body {
    font-family: 'Inter', sans-serif;
    background-color: #fffdf3;
    color: #333;
  }

  input, select, button { font-family: inherit; }

  @media (max-width: 1024px) { input, select, button { font-size: 14px; } }
  @media (max-width: 768px)  { input, select, button { font-size: 13px; } }

  .leaflet-container { width: 100%; height: 100%; z-index: 0; }
  .leaflet-container img.leaflet-image-layer,
  .leaflet-container .leaflet-tile { max-width: none !important; }
`;
export default GlobalStyle;
